module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_square_black.9ad4810a.png";